import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { h3, h4, paragraphSmall, tag } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  padding-bottom: 8px;
`;
const Link = styled.span `
  color: ${brand.black};
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &.focus-ring {
    outline: auto;
    outline-color: ${brand.black};
    outline-offset: 5px;
  }

  &[data-is-offer='true'] {
    background-color: transparent;
    border: none;
    width: 100%;
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(836, 454)};

  &[data-square-image='true'] {
    ${imageWrapperPreserveRatio(1, 1)};
  }

  margin-bottom: ${fluid(14, 16)};

  ${Container}[data-title-size="small"] & {
    margin-bottom: ${fluid(12, 14)};
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const Cta = styled.a `
  ${fonts.brandonGrotesque.medium};
  font-size: 18px;
  line-height: 1.5;
  text-decoration: none;
  text-underline-position: under;
  color: ${brand.black};
  ${transition('color')};
  margin-top: 8px;

  &:hover {
    color: ${brand.green};
  }
`;
const Title = styled.h3 `
  ${h3};

  margin-bottom: ${fluid(8, 12)};
  ${transition('text-decoration-color')};
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: transparent;

  ${Container}[data-title-size="small"] & {
    ${h4};

    margin-bottom: ${fluid(6, 10)};
  }

  ${Link}:hover & {
    text-decoration-color: ${brand.black};
  }
`;
const New = styled.span `
  color: ${brand.greenBright};
  ${transition('text-decoration-color')};
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: transparent;

  ${Link}:hover & {
    text-decoration-color: ${brand.black};
  }
`;
const SubTitle = styled.span `
  ${tag};

  display: block;
  margin-bottom: ${fluid(8, 12)};
  max-width: 275px;
  text-align: center;

  @media ${from(Device.DesktopSmall)} {
    max-width: 650px;
    margin-bottom: 8px;
  }

  ${Container}[data-title-size="small"] & {
    font-size: ${fluid(14, 16)};
    line-height: ${fluid(18, 20)};
    margin-bottom: ${fluid(6, 10)};
  }
`;
const RangeWrapper = styled.div `
  ${paragraphSmall};

  ${Container}[data-title-size="small"] & {
    font-size: ${fluid(14, 16)};
  }
`;
const Prefix = styled.span `
  margin-right: 5px;
  line-height: 1.2;
`;
const Ranges = styled.span `
  ${fonts.brandonGrotesque.bold};
`;
const RangeCount = styled.span `
  color: ${brand.green};
`;
const RangeCardStyles = {
    Container,
    Cta,
    Image,
    ImageWrapper,
    Link,
    New,
    Prefix,
    RangeCount,
    Ranges,
    RangeWrapper,
    SubTitle,
    Title,
};
export default RangeCardStyles;
